import React, { Component } from 'react'
import firebase from 'firebase'

// import { Link } from 'react-router'

import './styles/ViewAppStyles.css'
import Header from './Header'


import TopSection from './Sections/TopSection'
import TimeLineSection from './Sections/TimeLineSection'
import ThirdSection from './Sections/ThirdSection'
import CompetencySection from './Sections/CompetencySection'
import HowSection from './Sections/HowSection'
import ObjectsSection from './Sections/ObjectsSection'
import ContactFormSection from './Sections/ContactFormSection'
import ContactSection from './Sections/ContactSection'
import NewsSection from './Sections/NewsSection'
import Lines from './Lines'
import Loader from './Loader'
import Popover from './Popover'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import './styles/animate.css'
import './styles/mobile.css'
import 'bulma/css/bulma.css'


class ViewApp extends Component {

    constructor(props) {
        super(props)

        this.state = {
            data: false
        }
    }

    componentDidMount() {
        const dbRef = firebase.database().ref('/')

        dbRef.on('value', this.setData.bind(this))
    }

    setData(snapshot) {
        const data = snapshot.val()

        this.setState({
            data: data,
            popover: null
        })



    }

    getMenuItems() {
        return [
            { id: 'company', title: 'Компания' },
            { id: 'objects', title: 'Обьекты' },
            { id: 'competency', title: 'Компетенции' },
            { id: 'contacts', title: 'Контакты' },
        ]
    }

    render() {

        if (this.state.data) {
            return (
                <div className="FullWrapper">
                    <Header
                        menuItems={this.getMenuItems()}
                        appRootView={this}
                    />
                    {this.state.data.sections.topSection.isVisible ? (
                        <section ref={'company'}>
                            <TopSection appRootView={this} />
                        </section>
                    ) : null}

                    {this.state.data.sections.timeLineSection.isVisible ? (
                        <section ref={'timeline'}>
                            <TimeLineSection Popover={this.state.popover} appRootView={this} />
                        </section>
                    ) : null}

                    {this.state.data.sections.ThirdSection.isVisible ? (
                        <section ref={'thirdSection'}>
                            <ThirdSection appRootView={this} />
                        </section>
                    ) : null}

                    {this.state.data.sections.CompetencySection.isVisible ? (
                        <section ref={'competency'}>
                            <CompetencySection appRootView={this} />
                        </section>
                    ) : null}

                    {this.state.data.sections.HowSection.isVisible ? (
                        <section ref={'howweeork'}>
                            <HowSection appRootView={this} />
                        </section>
                    ) : null}

                    {this.state.data.sections.ObjectsSection.isVisible ? (
                        <section ref={'objects'}>
                            <ObjectsSection Popover={this.state.popover} appRootView={this} />
                        </section>
                    ) : null}

                    {this.state.data.sections.NewsSection.isVisible ? (
                        <section ref={'news'}>
                            <NewsSection appRootView={this} Popover={this.state.popover}/>
                        </section>
                    ) : null}

                    {this.state.data.sections.ContactFormSection.isVisible ? (
                        <section ref={'contactForm'}>
                            <ContactFormSection appRootView={this} />
                        </section>
                    ) : null}

                    {this.state.data.sections.ContactSection.isVisible ? (
                        <section ref={'contacts'}>
                            <ContactSection appRootView={this} />
                        </section>
                    ) : null}

                    <Lines color={'#9ccdfa'} />
                    <div style={{ zIndex: 99999 }} className="ToastWrapper">
                        <ToastContainer
                            position="top-right"
                            type="default"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            pauseOnHover
                        />
                    </div>

                    <Popover ref={(ref) => {
                        if (!this.state.popover) {
                            this.setState({
                                popover: ref
                            })
                        }
                    }} />

                </div>
            )
        } else {
            return (
                <div className="FullWrapper">
                    <Loader />
                </div>
            )
        }
    }
}

export default ViewApp


// WEBPACK FOOTER //
// ./src/Components/ViewApp.js